import CustomerVoucherSelectorList from "./customer-voucher-selector-list";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { use, useContext, useEffect, useRef } from "react";
import UiContext from "../../../../store/ui-context";

const titleDefault = "Choose Customer Voucher";

const CustomerVoucherSelectorMain = (props) => {
  const listRef = useRef(null);
  const { onConfirm, onHide, visible, title, additionalFilter, multiple } =
    props;

  const uiContext = useContext(UiContext);

  const _title = title ?? titleDefault;

  // handle ui event section

  // custom ui event section

  const dialogFooter = (
    <div className="row-end-end w-100 pt-2">
      <Button
        className="!w-[6.5rem]"
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={onHide}
      />
      <Button
        className="!w-[6.5rem]"
        label="Choose"
        icon="pi pi-check"
        onClick={(e) => {
          const listSelected = listRef.current.getSelectedData();
          if (!listSelected || listSelected.length === 0) {
            uiContext.showErrorMsg("Error", "Please select data first");
          } else {
            if (multiple) {
              onConfirm(e, listSelected);
            } else {
              onConfirm(e, [listSelected]);
            }
          }
          // onConfirm(e, refinedValue);
        }}
      />
    </div>
  );

  return (
    <Dialog
      visible={visible}
      header={_title}
      modal
      className={`p-fluid w-[50rem]`}
      footer={dialogFooter}
      onHide={onHide}
      contentStyle={{ paddingBottom: "0px" }}
    >
      <div className={`col-start-start w-100 gap-3 pt-1 `}>
        <CustomerVoucherSelectorList ref={listRef} {...props} />
      </div>
    </Dialog>
  );
};

export default CustomerVoucherSelectorMain;
